import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, MessageCircle } from "lucide-react";
import Services from "../components/Services";
import WhyUs from "../components/WhyUs";
import { siteData } from "../mock";

export default function ServicesPage() {
  const { primaryPhone, primaryPhoneRaw, whatsapp } = siteData.brand;
  return (
    <>
      <section className="py-20 md:py-28 bg-jk-cream border-b border-[#e7e2d7]">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="text-[11px] tracking-[0.32em] text-[#b88b4a] mb-5">OUR SERVICES</div>
          <h1 className="font-serif text-neutral-900 text-[44px] md:text-[76px] leading-[1.03] tracking-tight max-w-5xl">
            Residential. Commercial. Industrial. <span className="italic">End-to-end.</span>
          </h1>
          <p className="mt-7 text-neutral-700 text-[16px] md:text-[18px] leading-[1.85] max-w-3xl">
            Whatever your property goal — a first home, a flagship showroom, a manufacturing facility — we have the local depth to find it, negotiate it, and close it without drama.
          </p>
        </div>
      </section>

      <Services />
      <WhyUs />

      <section className="relative py-20 md:py-24 bg-jk-navy overflow-hidden">
        <div className="absolute inset-0 opacity-[0.06] pointer-events-none" style={{backgroundImage: "radial-gradient(circle at 20% 20%, #c6a071 1px, transparent 1px)", backgroundSize: "28px 28px"}} />
        <div className="relative max-w-5xl mx-auto px-5 md:px-10 text-center">
          <h2 className="font-serif text-white text-[36px] md:text-[52px] leading-[1.1] tracking-tight">
            Not sure where to start? <span className="italic text-[#c6a071]">Let&apos;s talk.</span>
          </h2>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href={`tel:${primaryPhoneRaw}`} className="btn-gold inline-flex items-center gap-2 px-7 py-4 text-[13.5px] tracking-wide font-medium">
              <Phone className="w-4 h-4" /> Call {primaryPhone}
            </a>
            <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer" className="btn-whatsapp inline-flex items-center gap-2 px-7 py-4 text-[13.5px] tracking-wide">
              <MessageCircle className="w-4 h-4" /> WhatsApp Us
            </a>
            <Link to="/properties" className="text-[#c6a071] hover:text-white inline-flex items-center gap-2 px-4 py-4 text-[13.5px] tracking-wide">
              Browse listings <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
